import React from 'react'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import FaIcon from '@/shared/ui/icons/FaIcon'
import { faTimes } from '@fortawesome/pro-duotone-svg-icons/faTimes'
import { AppDialogHeaderProps } from './types'

export default function AppDialogHeader({
    title,
    onClose,
}: AppDialogHeaderProps) {
    return (
        <DialogTitle
            sx={{
                p: 2,
                pr: onClose ? 5 : 2,
                position: 'relative',
                fontWeight: 'bold',
                fontSize: '1.5rem',
            }}
        >
            {title}
            {onClose && (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 16,
                        top: 16,
                        color: 'rgba(0, 0, 0, .87)',
                        width: '40px',
                        height: '40px',
                    }}
                >
                    <FaIcon icon={faTimes} size="lg" />
                </IconButton>
            )}
        </DialogTitle>
    )
}
